import { getUser } from '../firebase'
import type { InternalAxiosRequestConfig } from 'axios'

/**
 * Add request interceptor to attach the firebase auth token.
 *
 * user.getIdToken()
 *
 * Returns the current token if it has not expired or if it will not expire in
 * the next five minutes. Otherwise, this will refresh the token and return a
 * new one.
 *
 * @see https://firebase.google.com/docs/reference/js/auth.user.md#usergetidtoken
 */
export const authRequestInterceptor = async (
  config: InternalAxiosRequestConfig,
) => {
  const user = await getUser()

  if (user) config.headers['Authorization'] = await user.getIdToken()
  return config
}
